<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar` : 'Novo Cupom vs Comercializador' }}
            </h1>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Cupons vs Comercializador',
                href: `#/coupon-owners/${this.state.couponId}`,
              },
              {
                text: 'Cadastro de Cupons vs Comecializadores',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <!--               <b-form-group
                id="input-group-3"
                label="Perfil"
                label-for="input-group-3"
              >
                <select v-model="state.profile" class="form-control">
                  <option disabled value>Selecione o perfil</option>
                  <option value="consumer">Consumidor</option>
                  <option value="trader">Comercializador</option>
                  <option value="investor">Investidor</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('profile') }"></div>
                <b-form-invalid-feedback v-if="isOk('profile') === false">{{
                  getError('profile')
                }}</b-form-invalid-feedback>
              </b-form-group> -->

              <b-form-group label="Comissão">
                <b-form-input
                  class="text-right"
                  v-model="state.comission"
                  placeholder="Informe o valor da comissão"
                  :state="isOk('comission')"
                  @keypress="isNumber($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Selecione o Cupom"
                label-for="input-1"
              >
                <b-form-select
                  :disabled="true"
                  v-model="state.couponId"
                  :options="state.coupons"
                  :multiple="false"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Selecione o Comercializador"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.accountId"
                  :options="state.traders"
                  :multiple="false"
                ></b-form-select>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'coupon-owners-edit',
  data: function() {
    return {
      state: {
        name: '',
        comission: 0,
        accountId: 0,
        couponId: 0,
        profile: '',
        traders: [],
        coupons: [],
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    let isNew = this.$route.path.includes('new');
    const _id = this.$route.params && !isNew ? this.$route.params.id : 0;
    this.state.couponId = this.$route.params.id;

    this.state.traders = [];

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/coupon-owners/' + _id,
          method: 'get',
        });

        this.viewData.loading = false;
        this.state = { ...result.model };
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }

    try {
      this.viewData.loading = true;

      const result = await API.post('/execute', {
        path: '/traders',
        method: 'get',
      });

      this.state.traders = Object.keys(result.model)
        .map(item => {
          return result.model[item.toString()];
        })
        .map(item => {
          return {
            value: item.id,
            text: `${item.name}`,
          };
        });

      this.viewData.loading = false;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
    }

    try {
      this.viewData.loading = true;

      const result = await API.post('/execute', {
        path: '/coupons',
        method: 'get',
      });

      this.state.coupons = Object.keys(result.model.list)
        .map(item => {
          return result.model.list[item.toString()];
        })
        .map(item => {
          return {
            value: item.id,
            text: `${item.name} - ${item.description}`,
          };
        });

      this.viewData.loading = false;
      this.state.name = this.state.coupons.find(itm => {
        return item.id === this.state.couponId;
      }).name;
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    async save() {
      try {
        let data = _.cloneDeep(this.state);

        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/coupon-owners/${this.viewData.id}`
            : '/coupon-owners/',
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });

        this.$toast.success('Cupom vs Comercializador incluído com sucesso');

        this.$router.push(`/coupon-owners/${this.state.couponId}`);
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
